import { CommonModule } from '@angular/common';
import { Component, HostListener, computed, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DESKTOP_BREAKPOINT } from 'src/app/utility/constants';

@Component({
  selector: 'app-mobile-filter-collapse',

  imports: [CommonModule, TranslatePipe],
  templateUrl: './mobile-filter-collapse.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mobile-filter-collapse.component.scss',
})
export class MobileFilterCollapseComponent {
  showToggle = input(true);
  showLabelKey = input('general.showFilters');
  hideLabelKey = input('general.hideFilters');

  private isNarrowViewport = signal(typeof window !== 'undefined' ? window.innerWidth <= DESKTOP_BREAKPOINT : false);
  private isExpanded = signal(typeof window !== 'undefined' ? window.innerWidth > DESKTOP_BREAKPOINT : true);

  readonly toggleVisible = computed(() => this.showToggle() && this.isNarrowViewport());
  readonly contentVisible = computed(() => !this.toggleVisible() || this.isExpanded());

  @HostListener('window:resize')
  onResize() {
    const isNarrow = window.innerWidth <= DESKTOP_BREAKPOINT;
    this.isNarrowViewport.set(isNarrow);
    if (!isNarrow) {
      this.isExpanded.set(true);
    }
  }

  toggle() {
    this.isExpanded.update((value) => !value);
  }
}
